import { requestService } from '../helpers/request.service';

export const reportService = {
    /* Exporturi */
    RaportAbonamenteSpeciale,
    RaportAlocareTemporaraMM,

    /* Export Cautare */
    RaportCautareConsultatii,
    RaportCautareFiseMM,
    RaportCautarePreautorizari,
    RaportCautarePreautorizariMM,


    /* Export Cautare Pacienti */
    RaportCautarePacientAbonamente,
    RaportCautarePacientConsultatii,
    RaportCautarePacientFiseMM,
    RaportCautarePacientPreautorizari,
    RaportCautarePacientPreautorizariMM,
    /* Contestatii */
    RaportContestatii,
    RaportContestatiiMM,

    /* Alte documente */
    RaportFisaMM,
    RaportRaportMedical,
    RaportScrisoareMedicala,

    /* Rapoarte */
    RaportFiseMMPentruFacturare,
    ExportFiseMMPentruFacturare,
    RaportConsultatiiNefinalizate,
    RaportConsultatiiMMNefinalizate,
    ExportConsultatiiNefinalizate,
    ExportConsultatiiMMNefinalizate,
    RaportServiciiMedicalePentruFacturare,
    ExportServiciiMedicalePentruFacturare,
    RaportServiciiMedicalePrestate,
    ExportServiciiMedicalePrestate,
    RaportServiciiRespinse,
    ExportServiciiRespinse
}

function RaportAbonamenteSpeciale(params) { return requestService.get({ methodName: '/Raport/RaportAbonamenteSpeciale', queryString: params }); }
function RaportAlocareTemporaraMM(params) { return requestService.get({ methodName: '/Raport/RaportAlocareTemporaraMM', queryString: params }); }
function RaportCautareConsultatii(params) { return requestService.get({ methodName: '/Raport/RaportCautareConsultatii', queryString: params }); }

function RaportCautareFiseMM(params) { return requestService.get({ methodName: '/Raport/RaportCautareFiseMM', queryString: params }); }
function RaportCautarePreautorizari(params) { return requestService.get({ methodName: '/Raport/RaportCautarePreautorizari', queryString: params }); }
function RaportCautarePreautorizariMM(params) { return requestService.get({ methodName: '/Raport/RaportCautarePreautorizariMM', queryString: params }); }
function RaportCautarePacientAbonamente(params) { return requestService.get({ methodName: '/Raport/RaportCautarePacientAbonamente', queryString: params }); }
function RaportCautarePacientConsultatii(params) { return requestService.get({ methodName: '/Raport/RaportCautarePacientConsultatii', queryString: params }); }
function RaportCautarePacientFiseMM(params) { return requestService.get({ methodName: '/Raport/RaportCautarePacientFiseMM', queryString: params }); }
function RaportCautarePacientPreautorizari(params) { return requestService.get({ methodName: '/Raport/RaportCautarePacientPreautorizari', queryString: params }); }
function RaportCautarePacientPreautorizariMM(params) { return requestService.get({ methodName: '/Raport/RaportCautarePacientPreautorizariMM', queryString: params }); }
function RaportConsultatiiNefinalizate(params) { return requestService.get({ methodName: '/Raport/RaportConsultatiiNefinalizate', queryString: params }); }
function ExportConsultatiiNefinalizate(params) { return requestService.get({ methodName: '/Raport/ExportConsultatiiNefinalizate', queryString: params }); }
function RaportConsultatiiMMNefinalizate(params) { return requestService.get({ methodName: '/Raport/RaportConsultatiiMMNefinalizate', queryString: params }); }
function ExportConsultatiiMMNefinalizate(params) { return requestService.get({ methodName: '/Raport/ExportConsultatiiMMNefinalizate', queryString: params }); }

function RaportContestatii(params) { return requestService.get({ methodName: '/Raport/RaportContestatii', queryString: params }); }
function RaportContestatiiMM(params) { return requestService.get({ methodName: '/Raport/RaportContestatiiMM', queryString: params }); }
function RaportFisaMM(params) { return requestService.get({ methodName: '/Raport/RaportFisaMM', queryString: params }); }
function RaportFiseMMPentruFacturare(params) { return requestService.get({ methodName: '/Raport/RaportFiseMMPentruFacturare', queryString: params }); }
function ExportFiseMMPentruFacturare(params) { return requestService.get({ methodName: '/Raport/ExportFiseMMPentruFacturare', queryString: params }); }
function RaportRaportMedical(params) { return requestService.get({ methodName: '/Raport/RaportRaportMedical', queryString: params }); }
function RaportScrisoareMedicala(params) { return requestService.get({ methodName: '/Raport/RaportScrisoareMedicala', queryString: params }); }
function RaportServiciiMedicalePentruFacturare(params) { return requestService.get({ methodName: '/Raport/RaportServiciiMedicalePentruFacturare', queryString: params }); }
function ExportServiciiMedicalePentruFacturare(params) { return requestService.get({ methodName: '/Raport/ExportServiciiMedicalePentruFacturare', queryString: params }); }

function RaportServiciiMedicalePrestate(params) { return requestService.get({ methodName: '/Raport/RaportServiciiMedicalePrestate', queryString: params }); }
function ExportServiciiMedicalePrestate(params) { return requestService.get({ methodName: '/Raport/ExportServiciiMedicalePrestate', queryString: params }); }
function RaportServiciiRespinse(params) { return requestService.get({ methodName: '/Raport/RaportServiciiRespinse', queryString: params }); }
function ExportServiciiRespinse(params) { return requestService.get({ methodName: '/Raport/ExportServiciiRespinse', queryString: params }); }